/**
 * el-select
 * el-checkbox-group 
 * 按住shift多选or取消的指令
 */

let {
  start, // 起点变量
  cancelStart,  // 取消起点变量
  isSelected //默认不按住shift
} = [-1,-1,false];
export default {
  bind(el, binding, vnode) {
    const initEvent = ()=>{
      el.addEventListener("keydown",event=>{
        if(event.keyCode == 16&&event.shiftKey){
          isSelected = true;
        }
      })
      el.addEventListener("keyup",event=>{
        if(event.keyCode == 16){
          isSelected = false;
          start=-1
          cancelStart=-1;
        }
      })
    }
    initEvent();
  },
  update(el, binding, vnode,oldVnode){
    let typeAttr = vnode.elm.classList.value.includes("el-checkbox-group")?'label':"value"
    let itemList = vnode.componentOptions.children
    let modelValues =  vnode.data.model.value;
    if(modelValues instanceof Array){ // 表示为多选的select
      let oldModelValues = oldVnode.data.model.value
      if(oldModelValues.length>modelValues.length){ // 取消多选
        let cancelValue = oldModelValues.filter(item=>!modelValues.includes(item))
        let end = itemList.findIndex(item=>item.componentOptions.propsData[typeAttr] == cancelValue[0])
        // console.log(cancelStart+"============="+end)
        if(isSelected&&cancelStart!=-1){
          const sum = Math.abs(cancelStart-end)+1;  //终点
          const min = Math.min(cancelStart,end);  //起点
          let values = itemList.splice(min,sum)
          // console.log(min+"=======22222222222======"+sum)
          values.forEach(item=>{
            let value = item.componentOptions.propsData[typeAttr];
            let idx = vnode.data.model.value.findIndex(it=>it== value)
            if(idx!=-1){
              vnode.data.model.value.splice(idx,1)
            }
          })
        }else{
          cancelStart = end
        }
      }else if(modelValues.length>1){  //多选
        let segment = modelValues.slice(-2)
        let start = itemList.findIndex(item=>item.componentOptions.propsData[typeAttr] == segment[0])
        let end = itemList.findIndex(item=>item.componentOptions.propsData[typeAttr] == segment[1])
        if(isSelected&&start!=-1){
          const sum = Math.abs(start-end)+1;  //终点
          const min = Math.min(start,end);  //起点
          let values = itemList.splice(min,sum)
          values.forEach(item=>{
            let value = item.componentOptions.propsData[typeAttr];
            if(!modelValues.includes(value)){
              vnode.data.model.value.push(value)
            }
          })
        }else{
          start = end;
        }
      }
    }
  },
  unbind(el) {
    isSelected = false;
    start=-1
    cancelStart=-1;
  },
};